<template>
  <rest-form-page
    :page-title="pageTitle"
    :fetch-endpoint="fetchEndpoint"
    :save-endpoint="saveEnpoint"
    :after-save="afterSave"
    :model="model"
    :readonly="readonly"
  >
    <template slot="form" v-if="model">
      <form-section>
        <el-row>
          <el-col :span="12">
            <rest-form-item
              prop="webpushCode"
              :label="$t('ApplicationSDKIntegration_IntegrationCode')"
            >
              <textarea
                v-model="model.webpushCode"
                disabled
                autocomplete="off"
                class="textarea-copy-box"
              />
            </rest-form-item>
          </el-col>
          <el-col :span="12">
            <div class="info-text">
              <p>{{ $t('ApplicationSDKIntegration_IntegrationCodeHint') }}</p>
            </div>
          </el-col>
        </el-row>
      </form-section>
    </template>
  </rest-form-page>
</template>

<script>
import RestFormPage from '@/common/components/rest/RestFormPage'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'

export default {
  name: 'ApplicationSDKIntegrationPage',
  components: { RestFormItem, FormSection, RestFormPage },
  data() {
    return {
      model: {
        webpush_domain_hosted: '',
        is_chrome: '',
        is_firefox: '',
        webpush_window_mode: '',
        webpushCode: '',
        webpushServiceWorkerContent: '',
        webpush_sw_url: '',
        webpushManifestContent: '',
        webpush_manifest_url: '',
        webpushWindowContent: '',
        webpush_window_url: '',
        webpushFrameContent: '',
        webpush_frame_url: ''
      }
    }
  },
  computed: {
    pageTitle() {
      return this.$t(this.$route.meta.title)
    },
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `applications/${this.$route.query.id}`,
        params: {
          expand:
            'webpushCode,webpushServiceWorkerContent,webpushManifestContent,webpushWindowContent,webpushFrameContent'
        },
        handler: data => {
          this.model = data
        }
      })
    },
    saveEnpoint() {
      return projectEndpoint({
        method: 'patch',
        url: `applications/${this.$route.query.id}`,
        params: {
          expand:
            'webpushCode,webpushServiceWorkerContent,webpushManifestContent,webpushWindowContent,webpushFrameContent'
        }
      })
    },
    readonly() {
      return !this.$can('updateProjectItem')
    }
  },
  methods: {
    afterSave() {
      this.$router.push(
        projectRoute({
          name: 'Applications'
        })
      )
    }
  }
}
</script>

<style scoped>
.textarea-copy-box {
  overflow: scroll;
  resize: none;
  cursor: text;
  min-height: 33px;
  height: 138px;
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  width: 100%;
  line-height: 1.5;
  box-sizing: border-box;
  font-size: inherit;
  padding: 5px 15px;
}

.info-text {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 183px;
}

p {
  white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/modules/account/pages/ApplicationSDKIntegrationPage.vue